import { useBackend } from "../../services";
import { EquipmentStatus, IEquipmentGearItem } from "./interfaces";

export const useAddEquipment = () => {
  const { post } = useBackend();
  const addEquipment = (parameters: IAddEquipmentParameters) => post("equipments", parameters);
  return { addEquipment };
};

export interface IAddEquipmentParameters {
  name: string;
  description?: string;
  status: EquipmentStatus;
  gearItems: IEquipmentGearItem[];
}
